import type { FieldCommand, FieldSnapshot } from '@mio/shared';

export interface FieldPanelProps {
  snapshot: FieldSnapshot;
  busy: boolean;
  onAction: (action: FieldCommand['action']) => Promise<boolean>;
}

export const FIELD_INPUT =
  'border-line-strong bg-surface-raised text-fg placeholder:text-fg-subtle min-h-10 w-full rounded-md border px-3.5 py-2 text-sm transition-colors focus-visible:border-ring focus-visible:ring-ring/15 focus-visible:ring-3 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-60';
export const FIELD_LABEL = 'text-fg-muted mb-1.5 block text-xs font-medium';
